// extracted by mini-css-extract-plugin
export var wrapper = "faq-module--wrapper--3UPXV";
export var column = "faq-module--column--ExeV-";